//Match title height
function MatchHeight() {
  $('.match').matchHeight({});
}

$(document).ready(function() {
  MatchHeight(); 
  $('.article__content-meta').matchHeight(); 

  const scrollToTopButton = document.getElementById('js-top');
  const scrollFunc = () => {
    let y = window.scrollY;
    if (y > 0) {
      scrollToTopButton.className = "top-link shows";
    } else {
      scrollToTopButton.className = "top-link hide";
    }
  };
  window.addEventListener("scroll", scrollFunc);
  const scrollToTop = () => {
    const c = document.documentElement.scrollTop || document.body.scrollTop;
    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, c - c / 10);
    }
  };
  scrollToTopButton.onclick = function(e) {
    e.preventDefault();
    scrollToTop();
  }
  
  /*var banner_height = $('.announcement').height();
  console.log(banner_height)
  var s = $("#SiteHeader");
  var pos = s.position();					   
  $(window).scroll(function() {
    var windowpos = $(window).scrollTop();
    if (windowpos >= pos.top & windowpos > banner_height) {
      s.addClass("site-header--stuck");
      setTimeout(function() {
            s.addClass("site-header--opening");
          }, 100);
    } else {
      s.removeClass("site-header--stuck site-header--opening");	
    }
  });*/
  
  $('.quick-product__btn').on('click', function() {

    if($('.wc_product_review_badge').length > 0){
      var ajax_shop_badge_url = Shopify.shop, ajax_product_handle = new Array();
      $('.wc_product_review_badge').each(function(idx, val){
        ajax_product_handle.push($(this).data('handle'));
        if(idx === ($('.wc_product_review_badge').length - 1)){
          $.ajax({
            url: '//thimatic-apps.com/product_review/get_review_rating_update.php',
            type: 'post',
            dataType: 'json',
            data: {shop: ajax_shop_badge_url, product_handles: ajax_product_handle},
            success: function(result){
              $('.wc_product_review_badge').html(result.empty.html);
              $.each(result, function(key, value){
                $('.wc_product_review_badge[data-handle="'+key+'"]').html(value.html);
              });
            },
            error: function(XMLHttpRequest, textStatus){
              console.log(XMLHttpRequest);
            }
          });
        }
      });
    }
    
  });

});